import React, { useState, useEffect } from 'react';
import './AdminWrapper.css';
import AdminSideBar from '../AdminSideBar/AdminSideBar';
import AdminHome from '../AdminHome/AdminHome';
// import AdminFormAnswers from '../AdminFormAnswers/AdminFormAnswers';
// import AdminFormQuestions from '../AdminFormQuestions/AdminFormQuestions';
// import AdminFormQuestionnaire from '../AdminFormQuestionnaire/AdminFormQuestionnaire';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../utils/useAuthContext';
import { ACTIVE_URL } from '../../../constants';
import AdminFormQuestions from '../AdminFormQuestions/AdminFormQuestions';

const AdminWrapper: React.FC = () => {
    const navigate = useNavigate();
    const context = useAuthContext();
    const { authTokens } = useAuthContext();
    const [activeScreen, setActiveScreen] = useState<string>('Dashboard');

    const setActiveScreenHandler = (screen: string) => {
        setActiveScreen(screen);
    };


    useEffect(() => {
        const fetchResponses = async () => {
            if (!authTokens || !authTokens.access) {
                return;
            }
            try {
                const response = await fetch(`${ACTIVE_URL}/api/token/test_login/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authTokens.access}`,
                    }
                });
                if (response.ok) {
                    
                } else {
                    console.error('Failed to fetch responses');
                    if (response.status === 401) {
                        context.logoutUser();
                        navigate('/login');
                    }
                }
            } catch (error) {
                console.error('Error fetching responses:', error);
            }
        };

        fetchResponses();
    }, []);

    return (
        <div className='admin-wrapper'>
            <AdminSideBar activeScreen={activeScreen}  setActiveScreen={setActiveScreenHandler}  />
            <div className='admin-wrapper-content-wrapper'>
                {activeScreen === 'Dashboard' && <AdminHome />}
                {activeScreen === 'Assesments' && <AdminFormQuestions />}
                {/* {activeScreen === 'Results' && <AdminFormAnswers />}
                {activeScreen === 'Questions' && <AdminFormQuestions />}
                {activeScreen === 'Questionnaire' && <AdminFormQuestionnaire />} */}
            </div>

        </div>
    )
};

export default AdminWrapper;